import {
  getAuth,
  signInWithPopup,
  fetchSignInMethodsForEmail,
  linkWithPopup,
  FacebookAuthProvider,
} from "firebase/auth";
import { auth, Googleprovider } from "../../firebase/FirebaseConfig";
import { SOCIALLOGIN } from "../../constants/apiEndPoints";
import httpRequest from "../../axios/index";
import { toast } from "react-hot-toast";

const handleFacebookLogin = async () => {
  try {
    const response = await signInWithPopup(
      getAuth(),
      new FacebookAuthProvider()
    );
    return response;
  } catch (error) {
    if (error.code === "auth/account-exists-with-different-credential") {
      try {
        const email = error.email;

        // Continue with the account linking process.
        const methods = await fetchSignInMethodsForEmail(getAuth(), email);

        // Check if the Google provider is available in the list of sign-in methods for the email.
        if (methods.includes("google.com")) {
          // If the Google provider is available, link the new Facebook credential to the existing user account.
          const user = getAuth().currentUser;
          const facebookCredential =
            FacebookAuthProvider.credentialFromError(error);
          await linkWithPopup(user, facebookCredential);
          console.log("Accounts linked successfully!");
        } else {
          // If the Google provider is not available, handle the situation based on your app's logic.
          // For example, show an error message to the user indicating that the account with the same email exists
          // but was created using a different authentication method.
        }
      } catch (linkError) {
        console.error("Error during account linking:", linkError);
        return { error: "Error during account linking." };
      }
    } else {
      // Handle other errors here
      console.error("Error during Facebook login:", error);
      return { error: "Error during Facebook login." };
    }
  }
};

const HandleGoogleLogin = async () => {
  try {
    const response = await signInWithPopup(auth, Googleprovider);
    return response;
  } catch (error) {
    if (error.code === "auth/account-exists-with-different-credential") {
      try {
        const email = error.email;

        // Continue with the account linking process.
        const methods = await fetchSignInMethodsForEmail(auth, email);

        // Check if the Facebook provider is available in the list of sign-in methods for the email.
        if (methods.includes("facebook.com")) {
          // If the Facebook provider is available, link the new Google credential to the existing user account.
          const user = auth.currentUser;
          const googleCredential = Googleprovider.credentialFromError(error);
          await linkWithPopup(user, googleCredential);
          console.log("Accounts linked successfully!");
        } else {
          // If the Facebook provider is not available, handle the situation based on your app's logic.
          // For example, show an error message to the user indicating that the account with the same email exists
          // but was created using a different authentication method.
        }
      } catch (linkError) {
        console.error("Error during account linking:", linkError);
        return { error: "Error during account linking." };
      }
    } else {
      // Handle other errors here
      console.error("Error during Google login:", error);
      return { error: "Error during Google login." };
    }
  }
};

// this is for the api call
const SocialLoginApi = async (data = {}) => {
  try {
    const resp = await httpRequest.post(`${SOCIALLOGIN}`, data);
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  }
};

// logout the user

const FirebasehandleUserDelete = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      await user.delete();
      console.log("User account deleted successfully.");
    }
  } catch (error) {
    console.error("Firebase Error deleting user:", error);
  }
};

export {
  handleFacebookLogin,
  HandleGoogleLogin,
  SocialLoginApi,
  FirebasehandleUserDelete,
};
